import { assert } from '@/core';
import { BaseService } from './base.service'
import { ResponseWrapper } from './util';

export class IntakeFormService extends BaseService {

  static get entity() {
    return 'intake-forms';
  }

  /**
   * Fetch the submitted intake form data for a given appointment.
   * Staff-authenticated (admin/kiosk session).
   *
   * Returns the intake form field data as JSON — the caller is
   * responsible for rendering it into a form and generating a PDF
   * client-side (this endpoint does NOT return a PDF blob).
   *
   * @param {object} data - { appointmentId, purpose }
   */
  static async download(data = {}) {
    assert.object(data, { required: true });

    const response = await this.request({ auth: true }).post(`/intake-forms/download`, data);

    return new ResponseWrapper(response, response?.data?.data ?? response?.data);
  }
}
